module.exports = __webpack_public_path__ + "img/search-sentosa.21fb5cda.svg";